import React from 'react';
import styled from 'styled-components';
import { useTranslate } from '../../contexts/languageContext';
import { getUrl } from '../../utils';
import { Link } from 'react-router-dom';
import constantes from '../../resources/constantes.json';

/**
 * Tabla que muestra el ranking de municipios según el dato a comparar escogido (Para móvil)
 */

const TablaMunicipiosMobile = ({ title, data, nomenclator, elec }) => {
  const t = useTranslate();

  return (
    <ul>
      {data.map((x, index) => (
        <Item
          data={x}
          index={index}
          key={index}
          nomenclator={nomenclator}
          elec={elec}
          title={title}
          t={t}
        />
      ))}
    </ul>
  );
};

export default TablaMunicipiosMobile;

const Item = ({ data, index, nomenclator, elec, title, t }) => {
  const getDepartamento = (idamb, nomenclator, elec) => {
    const ambito = nomenclator.ambitos[elec][idamb];
    if (ambito) {
      const idDep = ambito.p[0];
      return nomenclator.ambitos[elec][idDep].n;
    }
    return idamb;
  };
  const dep = getDepartamento(data.idamb, nomenclator, elec);
  const act = { fontWeight: '900', fontSize: '1.3rem' };
  return (
    <Fila index={index}>
      <CeldaHead>
        <LinksWrapper>
          <SLink
            to={getUrl({
              id: data.idamb,
              eleccion: elec,
              page: constantes.nombreEleccion[elec],
              nomenclator,
            })}
          >{data.amb}</SLink>
          <SLink
            to={getUrl({
              id: nomenclator.ambitos[elec][data.idamb].p[0],
              eleccion: elec,
              page: constantes.nombreEleccion[elec],
              nomenclator,
            })}
          >{'(' + dep + ')'}</SLink>
        </LinksWrapper>
      </CeldaHead>
      <CeldaBody>
        <MesasBlock>
          <TxtDato>{t('mesasInf')}</TxtDato>
          <div style={act}>{data.pmesesc}</div>
        </MesasBlock>
        <div>
          <TxtDato>{title}</TxtDato>
          <div style={{ display: "flex", width: "100%", justifyContent: "space-around" }}>
            <div style={{ display: 'flex', flexDirection: "column" }}>
              <div style={act}> {constantes.años.añoAct}</div>
              <div style={act}> {data.pvot.act}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: "column", color: "gray" }}>
              <div style={act}> {constantes.años.añoAnt}</div>
              <div style={act}> {data.pvot.ant}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: "column", color: "gray" }}>
              <div style={act}> {constantes.años.añoAntAnt}</div>
              <div style={act}> {data.pvot.antant}</div>
            </div>
          </div>
        </div>
      </CeldaBody>
    </Fila>
  );
};

const Fila = styled.li`
  background: ${({ index }) => index % 2 === 0 && '#D8DFEA66'};
  padding: 1.6rem 1.8rem;
`;

const CeldaHead = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1.6rem;
`;

const CeldaBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const TxtDato = styled.div`
  font-size: 1.4rem;
  font-weight: bold;
`;

const LinksWrapper = styled.div`
  display: flex;
`;

const MesasBlock = styled.div`
  display: flex;
  justify-content:space-between;
  margin-bottom: 1.2rem;
`;

const SLink = styled(Link)`
  color: #164192;
  &:first-child {
    font-weight: bold;
    margin-right: 0.4em;
  }
`;
